import React, { useMemo, useState } from 'react';
import DataTable from 'react-data-table-component';
import { Form, Button } from 'react-bootstrap';
import EmptyState from './EmptyState';
import LoadingSkeleton from './LoadingSkeleton';
import styles from './DataTableWrapper.module.scss';
import { Inbox } from 'react-feather';

export default function DataTableWrapper({
  columns,
  data,
  loading,
  onRowClick,
  searchPlaceholder = 'Search…',
  actions = [],
  keyField = 'id',
  showSearch = true,
  selectableRows = false,
  onSelectedRowsChange,
  clearSelectedRows = false,
  dense = false,
  customTableProps = {},
}) {
  const [q, setQ] = useState('');

  const filtered = useMemo(() => {
    if (!showSearch || !q.trim()) return data || [];
    const needle = q.toLowerCase();
    return (data || []).filter((row) =>
      Object.values(row).some((v) => String(v ?? '').toLowerCase().includes(needle))
    );
  }, [data, q, showSearch]);

  if (loading) {
    return (
      <div className={styles.tableCard}>
        <div className="p-3">
          <LoadingSkeleton rows={8} cols={Math.min(4, columns?.length || 4)} />
        </div>
      </div>
    );
  }

  const empty = !filtered.length;

  return (
    <div>
      {(showSearch || actions.length > 0) && (
        <div className={styles.toolbar}>
          {showSearch ? (
            <Form.Control
              className={styles.search}
              type="search"
              placeholder={searchPlaceholder}
              value={q}
              onChange={(e) => setQ(e.target.value)}
              aria-label={searchPlaceholder}
            />
          ) : (
            <div />
          )}
          <div className={styles.actions}>
            {actions.map((a, i) => (
              <Button
                key={i}
                variant={a.variant || 'outline-primary'}
                size="sm"
                onClick={a.onClick}
                disabled={a.disabled}
              >
                {a.label}
              </Button>
            ))}
          </div>
        </div>
      )}
      <div className={styles.tableCard}>
        {empty ? (
          <div className={styles.emptyWrap}>
            <EmptyState
              icon={Inbox}
              title="No records"
              description="Try adjusting your search or filters."
            />
          </div>
        ) : (
          <DataTable
            columns={columns}
            data={filtered}
            keyField={keyField}
            pagination
            dense={dense}
            highlightOnHover
            striped
            selectableRows={selectableRows}
            onSelectedRowsChange={onSelectedRowsChange}
            clearSelectedRows={clearSelectedRows}
            onRowClicked={onRowClick}
            pointerOnHover={Boolean(onRowClick)}
            {...customTableProps}
          />
        )}
      </div>
    </div>
  );
}
